import React from 'react';
import MagazineImage from './MagazineImage';
import MagazineText from './MagazineText';
import MagazineMultiImage from './MagazineMultiImage';
import MagazineTitle from './MagazineTitle';
import MagazineAuthor from './MagazineAuthor';
var MagazineNode = function (_a) {
    var posts = _a.posts;
    if (!(posts === null || posts === void 0 ? void 0 : posts.length)) {
        return null;
    }
    return posts.map(function (post, index) {
        if (post.style === 'magazine_author') {
            return React.createElement(MagazineAuthor, { key: post.postId, post: post });
        }
        if (post.style === 'magazine_title') {
            return React.createElement(MagazineTitle, { key: post.postId, post: post });
        }
        if (post.style === 'image') {
            return React.createElement(MagazineImage, { key: post.postId, post: post });
        }
        if (['normal', 'colored'].includes(post.style)) {
            return React.createElement(MagazineText, { key: post.postId, post: post });
        }
        if (post.style === 'two_pictures') {
            return React.createElement(MagazineMultiImage, { key: post.postId, post: post });
        }
    });
};
export default MagazineNode;
//# sourceMappingURL=MagazineNode.js.mapimport React from 'react';
import MagazineImage from './MagazineImage';
import MagazineText from './MagazineText';
import MagazineMultiImage from './MagazineMultiImage';
import MagazineTitle from './MagazineTitle';
import MagazineAuthor from './MagazineAuthor';
var MagazineNode = function (_a) {
    var posts = _a.posts;
    if (!(posts === null || posts === void 0 ? void 0 : posts.length)) {
        return null;
    }
    return posts.map(function (post, index) {
        if (post.style === 'magazine_author') {
            return React.createElement(MagazineAuthor, { key: post.postId, post: post });
        }
        if (post.style === 'magazine_title') {
            return React.createElement(MagazineTitle, { key: post.postId, post: post });
        }
        if (post.style === 'image') {
            return React.createElement(MagazineImage, { key: post.postId, post: post });
        }
        if (['normal', 'colored'].includes(post.style)) {
            return React.createElement(MagazineText, { key: post.postId, post: post });
        }
        if (post.style === 'two_pictures') {
            return React.createElement(MagazineMultiImage, { key: post.postId, post: post });
        }
    });
};
export default MagazineNode;
//# sourceMappingURL=MagazineNode.js.map